import { LinearProgress, Tooltip } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Badge from '@material-ui/core/Badge';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import type { StyledComponentProps } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { DynamicFeedOutlined, Save } from '@material-ui/icons';
import AddIcon from '@material-ui/icons/Add';
import SettingsIcon from '@material-ui/icons/Settings';
import CoProducerClass from 'classes/CoProducer';
import ProductClass from 'classes/Product';
import Alert from 'components/Alert';
import { TOOLBAR_HEIGHT } from 'components/Layout';
import ModalActions from 'components/ModalActions';
import { constants } from 'helpers/constants';
import { EProductStatus } from 'helpers/enums';
import { functions } from 'helpers/functions';
import { EChargeType } from 'interfaces/IEditProduct';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import InfoDelivery from 'scenes/Producer/Product/components/InfoDeliveryMethods';
import InfoDeliveryValidations from 'scenes/Producer/Product/components/InfoDeliveryMethods/validations';
import Alumy from 'scenes/Producer/Product/components/Partners/Alumy';
import PhysicalDelivery from 'scenes/Producer/Product/components/PhysicalDeliveryMethods';
import PDCorreiosValidations from 'scenes/Producer/Product/components/PhysicalDeliveryMethods/Form/Correios/validations';
import PDFixedValueValidations from 'scenes/Producer/Product/components/PhysicalDeliveryMethods/Form/FixedValue/validations';
import PDFreeValidations from 'scenes/Producer/Product/components/PhysicalDeliveryMethods/Form/Free/validations';
import { VERTICAL_URL } from 'settings';
import { listCurrency } from 'store/Orbita/Currency/actions';
import { listNutrorCourses } from 'store/Orbita/NutrorCourse/actions';
import {
  cloneProductById,
  editProduct,
  getDeliveryIntegrationActiveList,
  listCategories,
  listCoProducers,
  listDeliveryMethods,
  listProductsChildren,
  loadProduct,
  newProduct,
} from 'store/Orbita/Product/actions';
import Truncate from 'v2/components/Shared/TruncateText';
import eduzzAccountsService from 'v2/services/eduzzAccount';
import { run } from 'validations/ruleRunner';

import AdvancedForm from './components/Advanced';
import AdvancedValidations from './components/Advanced/validations';
import Affiliate from './components/Affiliate';
import AffiliateValidations from './components/Affiliate/validations';
import CoProducer from './components/CoProducer';
import CoProducerFormValidations from './components/CoProducer/components/CoProducerForm/validations';
import CoProducerValidations from './components/CoProducer/validations';
import General from './components/General';
import MarketplaceValidation from './components/General/marketplaceValidation';
import GeneralValidations from './components/General/validations';
import PaymentMethods from './components/PaymentMethods';
import PaymentMethodValidations from './components/PaymentMethods/validations';
import Sales from './components/Sales';
import { allUsersSubscriptionValidation } from './components/Sales/components/Subscription/validations';
import SalesRecovery from './components/SalesRecovery/index';
import RecoveryValidations from './components/SalesRecovery/validations';
import styles from './components/styles';
import DraftButtons from '../components/DraftButtons';
import DraftLabel from '../components/DraftLabel';
import { isIntegrationActive, isIntegrationMelhorEnvio } from '../helpers';

import type { ActiveIntegrationResponse } from '../types';
import type ICoProducer from 'interfaces/ICoProducer';
import type IProduct from 'interfaces/IProduct';
import type { DispatchProp } from 'react-redux';
import type { RouteComponentProps } from 'react-router-dom';

enum eNameTabs {
  General = 'general',
  Sales = 'sales',
  PaymentMethods = 'paymentmethods',
  Coproducers = 'coproducers',
  Affiliates = 'affiliates',
  Delivery = 'delivery',
  InfoDelivery = 'infodelivery',
  PhysicalDelivery = 'physicaldelivery',
  SalesRecovery = 'salesrecovery',
  Advanced = 'advanced',
}

const coProducersLimitWithElevar = 16;
const coProducersLimitWithoutElevar = 15;

const MELHOR_ENVIO = '4';
const CORREIOS = '3';
const FIXEDVALUE = '2';
const FREE = '1';

interface IRouteParams {
  tab?: any;
  productId: any;
  variationId?: any;
  tabName?: any;
}

interface IPropsFromConnect {
  edit: any;
  product: any;
  coproducers: any;
  delivery: any;
  upload_id: any;
  categories: any;
  currencies: any;
  newProduct: any;
  variations: any;
  physicalDelivery: any;
  courses: any[];
  packages: any[];
  integration: ActiveIntegrationResponse;
}

interface IProps extends DispatchProp<any>, RouteComponentProps<IRouteParams>, StyledComponentProps, IPropsFromConnect {}

interface IStates {
  selectedProduct: IProduct;
  product: IProduct;
  variations: Array<IProduct>;
  isVariation: boolean;
  originalProduct: IProduct;
  modifieds: any;
  tabSelected: string;
  saving: boolean;
  loading: boolean;
  loadingGeneral: boolean;
  loadingCoProducers: boolean;
  loadingDeliveryMethods: boolean;
  generalRequiredFields: number;
  salesRequiredFields: number;
  coProducerRequiredFields: number;
  InfoDeliveryRequiredFields: any;
  PhysicalDeliveryRequiredFields: any;
  salesSinglePaymentRequiredFields: number;
  salesSubscriptionRequiredFields: number;
  advancedRequiredFields: number;
  affiliatesRequiredFields: number;
  paymentMethodsRequiredFields: number;
  recoveryRequiredFields: number;
  selected: any;
  productId: any;
  variationId: any;
  editing: boolean;
  confirmModal: boolean;
  nextItem: any;
  variationModal: boolean;
  prevSelected?: IProduct;
  alert: boolean;
  oldEdit: boolean;
  cancelModalCallback: undefined | (() => void);
}

const PROJECT_ELEVAR_ID = [75879698];

class Product extends Component<IProps, IStates> {
  validation: any;
  constructor(props: IProps) {
    super(props);
    this.state = {
      originalProduct: new ProductClass(),
      isVariation: false,
      variations: null,
      product: new ProductClass(),
      selectedProduct: new ProductClass(),
      modifieds: {},
      tabSelected: eNameTabs.General,
      saving: false,
      loading: true,
      loadingGeneral: true,
      loadingCoProducers: true,
      loadingDeliveryMethods: true,
      generalRequiredFields: 0,
      salesRequiredFields: 0,
      advancedRequiredFields: 0,
      coProducerRequiredFields: 0,
      InfoDeliveryRequiredFields: 0,
      PhysicalDeliveryRequiredFields: 0,
      salesSinglePaymentRequiredFields: 0,
      salesSubscriptionRequiredFields: 0,
      affiliatesRequiredFields: 0,
      paymentMethodsRequiredFields: 0,
      recoveryRequiredFields: 0,
      selected: null,
      productId: null,
      variationId: null,
      editing: false,
      confirmModal: false,
      nextItem: null,
      variationModal: false,
      alert: localStorage.getItem('news_myproducts_unlimited_installment') === 'true',
      oldEdit: false,
      cancelModalCallback: undefined,
    };
    this.props.dispatch(listCurrency());
    this.props.dispatch(listCategories());
    this.closeAlert = this.closeAlert.bind(this);
    this.onOldEditCancel = this.onOldEditCancel.bind(this);
    this.onOldEditOk = this.onOldEditOk.bind(this);
  }

  copyFromOriginal = () => {
    let { selectedProduct, prevSelected } = this.state;
    let prod: IProduct;
    prod = {
      ...prevSelected.getGeneralProperties(),
      ...prevSelected.getSalesProperties(),
      ...prevSelected.getAffiliatesProperties(),
    };
    selectedProduct = new ProductClass({ ...selectedProduct, ...prod });
    selectedProduct.setCoProducers(prevSelected.getCoProducers());
    selectedProduct.setDeliveries(prevSelected.getDeliveries());
    if (prevSelected.type === constants.PHYSICAL) {
      const delivery = prevSelected.getPhysicalDelivery();
      selectedProduct.setPhysicalDelivery(delivery);
      this.props.dispatch({ type: 'CHANGE_PHYSICAL_DELIVERY', delivery });
    }
    this.setState({ selectedProduct, modifieds: { copied: true } });
    toast.success('Dados copiados com sucesso!');
    this.verifyValidations(selectedProduct);
  };

  handleChange = (name: string, value: any, callback?: Function) => {
    const currentProduct = this.state.selectedProduct;
    currentProduct[name] = value;
    const newProduct: IProduct = new ProductClass(currentProduct);
    const newModifieds = Object.assign({}, this.state.modifieds);
    if (name !== 'recurring_frequency_type_select') newModifieds[name] = true;
    this.setState({ selectedProduct: newProduct, modifieds: newModifieds }, () => {
      if (functions.isFunction(callback)) {
        callback();
      }
    });
  };

  loadingCurrentProduct(id: any) {
    if (id) {
      (async () => {
        try {
          this.setState({ loading: true, loadingCoProducers: true, loadingDeliveryMethods: true });
          await this.props.dispatch(listCoProducers(id));
          // Tive que fazer isso para tratar o jeito que vem da API
          let cps = this.props.coproducers;
          cps.active.forEach((item: ICoProducer) => {
            item.active = true;
          });
          cps.pending.forEach((item: ICoProducer) => {
            item.active = false;
            item.pending = true;
          });
          const cops = cps.active.concat(cps.pending);
          let { selectedProduct } = this.state;
          selectedProduct.setCoProducers(cops);
          this.setState({ selectedProduct, loadingCoProducers: false });
          await Promise.all([this.props.dispatch(listDeliveryMethods(id)), this.props.dispatch(listNutrorCourses())]);
          selectedProduct.setDeliveries(this.props.delivery);
          if (selectedProduct.type === constants.PHYSICAL) {
            const delivery = selectedProduct.getPhysicalDelivery();

            this.props.dispatch({ type: 'CHANGE_PHYSICAL_DELIVERY', delivery });
          }
          this.setState({ selectedProduct, loadingDeliveryMethods: false });
          this.setState({ loading: false });
          this.verifyValidations(selectedProduct);
        } catch (error) {
          toast.error(error);
          this.setState({ loading: false });
        }
      })();
    }
  }

  onAddNewDeliveryPartner = () => {
    const { selectedProduct } = this.state;
    let newCoProducers = selectedProduct.getCoProducers();
    // TODO HARD CODED PARCEIRO ENTREGA
    const exist = newCoProducers.find((item: any) => item.email === 'kaiser@kapsula.com.br');
    if (exist) {
      toast.warn('Parceiro de entrega já faz parte dos parceiros deste produto');
      return;
    }
    let newCoproducer = new CoProducerClass({
      email: 'kaiser@kapsula.com.br',
      business_name: 'Kapsula Produtos Naturais Ltda',
      customer_id: 16640004,
      new: true,
      comission_type: 'P',
      isDeliveryPartner: true,
    });
    newCoProducers.push(newCoproducer);
    this.handleChangeCoproducer(newCoProducers);
    this.setState({ tabSelected: eNameTabs.Coproducers });
    toast.success('Parceiro de entrega adicionado com sucesso');
  };

  onRemoveDeliveryPartner = () => {
    const { selectedProduct } = this.state;
    let newCoProducers = selectedProduct.getCoProducers();
    // TODO HARD CODED PARCEIRO ENTREGA
    const hasPartner = newCoProducers.some((item) => item.email === 'kaiser@kapsula.com.br');
    if (!hasPartner) return;
    const nps = newCoProducers.filter((item: any) => item.email !== 'kaiser@kapsula.com.br');
    this.handleChangeCoproducer(nps);
    toast.success('Parceiro de entrega removido com sucesso');
  };

  handleChangeTab = (e: any, value: string) => {
    this.setState({ tabSelected: value });
  };

  handleChangeCoproducer = (newCops: Array<ICoProducer>) => {
    let { modifieds, selectedProduct } = this.state;

    if (modifieds) {
      modifieds.coproducers = 'edited';
    } else {
      modifieds = { coproducers: 'edited' };
    }
    selectedProduct.setCoProducers(newCops);
    this.setState({ selectedProduct, modifieds });
  };

  handleChangeDeliveries = (deliveries: any) => {
    let { selectedProduct } = this.state;
    selectedProduct.setDeliveries(deliveries);
    this.setState({ selectedProduct });
  };

  onChangeItem = (id: number) => {
    const { modifieds } = this.state;
    const hasModified = Object.keys(modifieds).length;
    if (hasModified) {
      this.setState({ confirmModal: true, nextItem: id });
    } else {
      this.changeItem(id);
    }
  };

  changeItem = (id: number) => {
    let { product, variations, tabSelected, variationId } = this.state;
    let selectedProduct: IProduct;

    if (product.id === id) {
      selectedProduct = new ProductClass(product);
      tabSelected = eNameTabs.General;
      variationId = null;
    } else {
      selectedProduct = new ProductClass(variations.find((it: any) => it.id === id));
      variationId = id;
    }

    if (id === 0 && selectedProduct.type === constants.PHYSICAL) {
      this.props.dispatch({ type: 'RESET_PHYSICAL_DELIVERY' });
    }

    this.loadingCurrentProduct(id);
    this.setState({ selected: id, selectedProduct, confirmModal: false, modifieds: {}, tabSelected, variationId });
  };

  onOkModal = () => {
    if (!this.formHasError()) {
      (async () => {
        try {
          this.setState({ confirmModal: false });
          await this.handleSubmit();
          this.changeItem(this.state.nextItem);
        } catch (error) {}
      })();
    } else {
      this.setState({ confirmModal: false });
    }
  };

  onCancelModal = () => {
    const { product, cancelModalCallback } = this.state;
    const isCreatingNewVariation = product.isVariation() && !product.id;

    if (isCreatingNewVariation) {
      this.changeItem(this.state.nextItem);
    }

    cancelModalCallback?.();
    this.setState({ confirmModal: false });
  };

  confirmCreateNewVariation = () => {
    const { product } = this.state;

    if (Alumy.isAlumy(product.cnt_partner_cod)) {
      Alumy.alumyModal();

      return;
    }

    this.setState({ variationModal: true });
  };

  onVariationModalOk = () => {
    this.setState({ variationModal: false });
    this.newVariation();
  };

  onVariationModalClose = () => {
    this.setState({ variationModal: false });
  };

  onChangeRequiredFields = () => {
    const { selectedProduct } = this.state;
    if (selectedProduct.type === constants.PHYSICAL) {
      selectedProduct.physicalDelivery = this.props.physicalDelivery;
    }
    this.verifyValidations(selectedProduct);
  };

  newVariation = () => {
    let { product, variations, selectedProduct } = this.state;

    if (Alumy.isAlumy(product.cnt_partner_cod)) {
      Alumy.alumyModal();
      return;
    }

    let newVariation = new ProductClass({ type: product.type, deliveries: [] });
    if (product.hasVariations()) {
      const existNewVariation = variations.find((item: IProduct) => item.id === 0);
      if (existNewVariation) {
        toast.info('Existe uma nova variação que ainda não foi salva, por favor salve a variação antes de criar uma nova');
        return;
      }
      newVariation.setParent(product.id);
      //DEFAULT PRODUCER AS COPRODUCER IN ALL VARIATIONS
      newVariation.setCoProducers([selectedProduct.coproducers[0]]);
      newVariation.setDeliveries(null);
      if (newVariation.type === constants.PHYSICAL) {
        this.props.dispatch({ type: 'RESET_PHYSICAL_DELIVERY' });
      }
      variations.push(newVariation);
      this.setState({
        prevSelected: selectedProduct,
        variations,
        selectedProduct: newVariation,
        selected: newVariation.id,
        tabSelected: eNameTabs.General,
      });
      this.verifyValidations(newVariation);
    } else {
      (async () => {
        this.setState({ saving: true });
        await this.props.dispatch(cloneProductById(product.id, product.id));
        this.setState({ saving: false });
        //this.forceUpdate is not working, best way is call componentWilMount as recomendation https://github.com/facebook/react/issues/3071
        this.loadProduct(() => {
          let newVariation = new ProductClass({ type: product.type, deliveries: [] });
          let { variations } = this.state;
          newVariation.setParent(product.id);
          //DEFAULT PRODUCER AS COPRODUCER IN ALL VARIATIONS
          newVariation.setCoProducers([selectedProduct.coproducers[0]]);
          if (newVariation.type === constants.PHYSICAL) {
            this.props.dispatch({ type: 'RESET_PHYSICAL_DELIVERY' });
          }
          variations.push(newVariation);
          this.setState({
            prevSelected: selectedProduct,
            variations,
            selectedProduct: newVariation,
            selected: newVariation.id,
            tabSelected: eNameTabs.General,
          });
          this.verifyValidations(newVariation);
        });
      })();
    }
  };

  formHasError: Function = (): boolean => {
    let hasError: boolean = false;
    const {
      generalRequiredFields,
      advancedRequiredFields,
      salesRequiredFields,
      coProducerRequiredFields,
      InfoDeliveryRequiredFields,
      PhysicalDeliveryRequiredFields,
      affiliatesRequiredFields,
      paymentMethodsRequiredFields,
      selectedProduct,
    } = this.state;
    if (selectedProduct.isMainWithChildren()) {
      if (generalRequiredFields > 0) {
        hasError = true;
        let tabSelected = eNameTabs.General;
        toast.error('Existem campos inválidos no produto, por favor verifique-os antes de salvar');
        this.setState({ tabSelected });
      }
    } else {
      if (
        generalRequiredFields +
          salesRequiredFields +
          coProducerRequiredFields +
          InfoDeliveryRequiredFields +
          PhysicalDeliveryRequiredFields +
          advancedRequiredFields +
          paymentMethodsRequiredFields +
          affiliatesRequiredFields >
        0
      ) {
        hasError = true;
        let tabSelected = eNameTabs.General;
        if (generalRequiredFields) {
        } else if (salesRequiredFields > 0) {
          tabSelected = eNameTabs.Sales;
        } else if (coProducerRequiredFields > 0) {
          tabSelected = eNameTabs.Coproducers;
        } else if (affiliatesRequiredFields > 0) {
          tabSelected = eNameTabs.Affiliates;
        } else if (InfoDeliveryRequiredFields > 0) {
          tabSelected = eNameTabs.InfoDelivery;
        } else if (advancedRequiredFields > 0) {
          tabSelected = eNameTabs.Advanced;
        }
        if (selectedProduct.type === constants.PHYSICAL) {
          if (PhysicalDeliveryRequiredFields > 0) {
            tabSelected = eNameTabs.PhysicalDelivery;
          }
        }
        toast.error('Existem campos inválidos no produto, por favor verifique-os antes de salvar');
        this.setState({ tabSelected });
      }
    }
    return hasError;
  };

  verifyValidations: Function = (product: IProduct): void => {
    let generalRequiredFields = 0;

    const GeneralErrors = run(product, GeneralValidations);
    generalRequiredFields = GeneralErrors ? Object.keys(GeneralErrors).length : 0;

    if (product.hasVariations() && !product.parent_id) {
      const MarketplaceErrors = run(product, MarketplaceValidation);
      generalRequiredFields += MarketplaceErrors ? Object.keys(MarketplaceErrors).length : 0;
    }

    const AffiliateErrors = product?.allow_affiliation ? run(product, AffiliateValidations) : 0;
    const affiliatesRequiredFields = AffiliateErrors ? Object.keys(AffiliateErrors).length : 0;

    let salesRequiredFields = 0;
    let advancedRequiredFields = 0;
    let InfoDeliveryRequiredFields = 0;
    let coProducerRequiredFields = 0;
    let PhysicalDeliveryRequiredFields = 0;
    let paymentMethodsRequiredFields = 0;
    let recoveryRequiredFields = 0;

    if (product && !product.isMainWithChildren()) {
      const AdvancedErrors = run(product, AdvancedValidations);
      advancedRequiredFields = AdvancedErrors ? Object.keys(AdvancedErrors).length : 0;

      const paymentMethodErrors = run(product, PaymentMethodValidations);
      paymentMethodsRequiredFields = paymentMethodErrors ? Object.keys(paymentMethodErrors).length : 0;

      const recoveryErrors = run(product, RecoveryValidations);
      recoveryRequiredFields = recoveryErrors ? Object.keys(recoveryErrors).length : 0;

      if (product && product.charge_type === 'A') {
        const SubscriptionErrors = run(product, allUsersSubscriptionValidation);
        salesRequiredFields += SubscriptionErrors ? Object.keys(SubscriptionErrors).length : 0;
      }

      let coErrors = run(product, CoProducerValidations);
      let CoproducerErrors = coErrors ? Object.keys(coErrors).length : 0;

      if (product && Array.isArray(product.coproducers)) {
        for (let i = 0; i < product.coproducers.length; i++) {
          const errors = run(product.coproducers[i], CoProducerFormValidations());
          const totalErrors = errors ? Object.keys(errors).length : 0;
          CoproducerErrors += totalErrors;
        }
      }

      coProducerRequiredFields = CoproducerErrors;
      InfoDeliveryRequiredFields = 0;
      if (product.type == constants.INFO) {
        const InfoDeliveryErrors = run(product, InfoDeliveryValidations);
        InfoDeliveryRequiredFields = InfoDeliveryErrors ? Object.keys(InfoDeliveryErrors).length : 0;
      }
      if (product.type == constants.PHYSICAL) {
        if (product.physicalDelivery && product.physicalDelivery.delivery_type === FIXEDVALUE) {
          const PDFixedValueErrors = run(product.physicalDelivery, PDFixedValueValidations);
          PhysicalDeliveryRequiredFields += PDFixedValueErrors ? Object.keys(PDFixedValueErrors).length : 0;
        } else if (product.physicalDelivery && product.physicalDelivery.delivery_type === FREE) {
          const PDFreeErrors = run(product.physicalDelivery, PDFreeValidations);
          PhysicalDeliveryRequiredFields += PDFreeErrors ? Object.keys(PDFreeErrors).length : 0;
        } else if (product.physicalDelivery && product.physicalDelivery.delivery_type === CORREIOS) {
          const PDCorreiosErrors = run(product.physicalDelivery || {}, PDCorreiosValidations);
          PhysicalDeliveryRequiredFields += PDCorreiosErrors ? Object.keys(PDCorreiosErrors).length : 0;
        }
      }
    }
    this.setState({
      generalRequiredFields,
      salesRequiredFields,
      InfoDeliveryRequiredFields,
      advancedRequiredFields,
      coProducerRequiredFields,
      PhysicalDeliveryRequiredFields,
      affiliatesRequiredFields,
      paymentMethodsRequiredFields,
      recoveryRequiredFields,
    });
  };

  handleClickPriceSubmit = async () => {
    const confirm = await Alert.show({
      message: 'Você está alterando o valor de novas assinaturas, onde contratos antigos não serão impactados. Deseja reajustar os antigos também?',
      title: 'Aviso sobre contratos antigos',
      buttonOk: 'Ir para reajustes',
      buttonCancel: 'Manter para novos contratos',
      confirmation: true,
    });
    if (confirm) {
      await this.handleSubmit();
      window.location.href = `${VERTICAL_URL}/subscriptions/readjustment`;
      return;
    }
    this.handleSubmit();
  };

  handleClickSubmitDraft = async () => {
    const confirm = await Alert.show({
      message: 'Salve seu produto e continue editando depois, ainda não será gerado um link de vendas do checkout.',
      title: 'Salvar como rascunho',
      confirmation: true,
    });
    if (confirm) {
      this.handleSubmit(true);
    }
    return;
  };
  handleClickSubmit = async () => {
    const confirm = await Alert.show({
      message: 'O seu produto será enviado para moderação e você receberá o seu link para vendê-lo. Deseja Continuar?',
      title: 'Atenção!',
      confirmation: true,
    });
    if (confirm) {
      this.handleSubmit();
    }
    return;
  };

  handleDelivery = (selectedProduct: IProduct, delivery_type: string, deliveriesWithoutNutrorHash: any[], courses: any[], packages: any[]) => {
    if (delivery_type === MELHOR_ENVIO) {
      this.props.dispatch(getDeliveryIntegrationActiveList());
    }

    const adjustDeliveriesWithoutNutrorHash = deliveriesWithoutNutrorHash.map((deliveryItem) => {
      const c = courses ?? [];
      const p = packages ?? [];
      const course = [...c, ...p].find((co) => co.id == deliveryItem?.nutror_id);
      if (course) {
        deliveryItem.nutror_hash = course.hash;
      }
      return deliveryItem;
    });
    return [...selectedProduct.getDeliveries().filter((d) => !!d.nutror_hash), ...adjustDeliveriesWithoutNutrorHash];
  };

  convertToNumber = (value: string) => {
    return Number(value.toString().replace(',', '.'));
  }

  handleSubmit = async (isDraft: boolean = false) => {
    const { selectedProduct, variations } = this.state;
    const { delivery_type } = this.props.physicalDelivery;
    const { courses, packages } = this.props;
    const newCoProducers = selectedProduct.getCoProducersForSubmit();
    const deliveriesWithoutNutrorHash: any[] = JSON.parse(JSON.stringify(selectedProduct.getDeliveries().filter((d) => !d.nutror_hash)));
    const sumComissions = newCoProducers.reduce((prev, current) => {
      if (typeof current.comission_value === 'string') {
        return prev + this.convertToNumber(current.comission_value as any)
      }
      return prev + current.comission_value;
    }, 0);

    if (sumComissions !== 100) {
      toast.error('A soma dos percentuais de ganho devem ser igual a 100%.')
      return;
    }

    selectedProduct.active = EProductStatus.ACTIVE;

    if (isDraft) {
      selectedProduct.active = EProductStatus.DRAFT;
    }

    if (!selectedProduct.isMainWithChildren()) {
      if (newCoProducers && Array.isArray(newCoProducers)) {
        const newCps = newCoProducers.filter((item: any) => item.active || (!item.pending && (item.new || item.edited)));
        if (newCps && Array.isArray(newCps) && newCps.length) {
          for (let i = 0; i < newCps.length; i++) {
            newCps[i]['comission_value'] = Number(functions.clearMoneyMask(newCps[i]['comission_value']));
          }
        }
        selectedProduct.setCoProducers(newCps);
      }
    }

    const newDeliveries = this.handleDelivery(selectedProduct, delivery_type, deliveriesWithoutNutrorHash, courses, packages);

    if (newDeliveries) {
      selectedProduct.setDeliveries(newDeliveries);
    }

    if (selectedProduct.type === constants.PHYSICAL) {
      selectedProduct.physicalDelivery = this.props.physicalDelivery;
      this.props.product.physicalDelivery = this.props.physicalDelivery;
    }
    await this.verifyValidations(selectedProduct);
    if (isDraft || !this.formHasError()) {
      this.setState({ saving: true });
      (async () => {
        try {
          let id: number;
          try {
            if (selectedProduct.id === 0) {
              await this.props.dispatch(newProduct(selectedProduct.serviceFormat()));
              id = this.props.newProduct.id;
              const vars: IProduct[] = variations.map((v) => {
                if (v.id === 0) return this.props.newProduct;
                return v;
              });
              this.setState({ variations: vars });
            } else {
              id = selectedProduct.id;
              await this.props.dispatch(editProduct(id, selectedProduct.serviceFormat()));
            }
          } catch (error) {
            this.setState({ saving: false });
            throw error;
          }
          toast.success('Produto salvo com sucesso.');
          (window as any).sumCoproducersComissions = null;
          this.loadProduct(() => this.setState({ saving: false, modifieds: {}, selected: id }));
        } catch (error) {
          toast.error(error);
        }
      })();
    }
  };

  closeAlert() {
    localStorage.setItem('news_myproducts_unlimited_installment', 'true');
    this.setState({ alert: true });
  }

  onOldEditOk() {
    localStorage.setItem('old_edit', 'true');
    this.setState({ oldEdit: true });
  }

  onOldEditCancel() {
    localStorage.setItem('old_edit', 'false');
    this.setState({ oldEdit: true });
  }

  componentDidMount() {
    this.loadProduct();
    this.props.dispatch(getDeliveryIntegrationActiveList());
  }

  loadProduct = async (callback?: () => void) => {
    const { productId, variationId, tabName } = this.props.match.params;
    const isVariation = !Object.values(eNameTabs).includes(variationId);
    const defaultTab = tabName || eNameTabs.General;
    const currentTab = isVariation ? defaultTab : variationId;
    let currentSelectedProduct: IProduct;

    this.setState({ tabSelected: currentTab });

    if (!productId) {
      this.props.history.goBack();
      toast.error('Produto não encontrado');
    }

    await this.props.dispatch(loadProduct(productId));
    let mainProduct = new ProductClass(this.props.product);
    currentSelectedProduct = mainProduct;

    if (!mainProduct.isMainProduct()) {
      await this.props.dispatch(loadProduct(mainProduct.parent_id));
      mainProduct = new ProductClass(this.props.product);
    }

    await this.setState({ product: mainProduct });

    if (mainProduct.hasVariations()) {
      await this.props.dispatch(listProductsChildren(mainProduct.id));
      let variations: Array<IProduct> = this.props.variations;
      variations = variations.map((item: IProduct) => {
        let newItem = new ProductClass(item);
        newItem.setCategories(mainProduct.getIdCategories());
        return newItem;
      });
      await this.setState({ variations });
      if (isVariation) {
        const selectedVariation: IProduct = new ProductClass(variations.find((item) => item.id === Number(variationId)));
        if (selectedVariation?.id) {
          currentSelectedProduct = selectedVariation;
          await this.setState({ variationId });
        }
      }
    }

    await this.setState({
      selected: currentSelectedProduct.id,
      selectedProduct: currentSelectedProduct,
    });

    this.handleMarketplace();

    this.setState({ loadingGeneral: false });
    await this.loadingCurrentProduct(this.state.selected);

    if (callback) callback();
  };

  isMelhorEnvioActive = () => {
    const { integration } = this.props;
    return isIntegrationActive(integration) && isIntegrationMelhorEnvio(integration);
  };

  openConfirmModal = (cancelModalCallback?: undefined | (() => void)) => {
    this.setState({ confirmModal: true, cancelModalCallback });
  };

  handleMarketplace = () => {
    const { variations, selectedProduct } = this.state;
    if (selectedProduct.hasVariations()) {
      const marketplaceActive = variations?.find((variation) => variation.marketplace);
      if (!marketplaceActive) return;
      selectedProduct.marketplace = marketplaceActive.marketplace;
      selectedProduct.marketplace_variation = marketplaceActive.id;
    }
  };

  componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IStates>): void {
    const { tabSelected, variationId } = this.state;
    const { productId } = this.props.match.params;
    if (tabSelected !== prevState.tabSelected || variationId !== prevState.variationId) {
      if (variationId) {
        this.props.history.replace(`/producer/product/editproduct/${productId}/${variationId}/${tabSelected}`);
        return;
      }
      this.props.history.replace(`/producer/product/editproduct/${productId}/${tabSelected}`);
    }
  }

  render() {
    const { classes, categories } = this.props;
    const {
      loadingGeneral,
      loadingCoProducers,
      loadingDeliveryMethods,
      editing,
      saving,
      loading,
      generalRequiredFields,
      advancedRequiredFields,
      salesRequiredFields,
      coProducerRequiredFields,
      affiliatesRequiredFields,
      InfoDeliveryRequiredFields,
      PhysicalDeliveryRequiredFields,
      paymentMethodsRequiredFields,
      recoveryRequiredFields,
      selectedProduct,
      selected,
      product,
      tabSelected,
      modifieds,
      variations,
    } = this.state;

    const hasVariations = product.hasVariations();
    const hasModifiedRecurringValue = 'recurring_value' in modifieds;

    const isValid = (() => {
      return [
        loadingGeneral,
        loadingCoProducers,
        loadingDeliveryMethods,
        editing,
        saving,
        loading,
        generalRequiredFields,
        advancedRequiredFields,
        salesRequiredFields,
        coProducerRequiredFields,
        affiliatesRequiredFields,
        InfoDeliveryRequiredFields,
        PhysicalDeliveryRequiredFields,
        paymentMethodsRequiredFields,
        recoveryRequiredFields,
      ].reduce((accumulator: any, currentValue: any) => accumulator + currentValue);
    })();

    const isMainProduct = selectedProduct?.isMainWithChildren();
    const isInfo = selectedProduct?.type === constants.INFO;
    const isPhysical = selectedProduct?.type === constants.PHYSICAL;
    const isService = selectedProduct?.type === constants.SERVICE;
    const isTicket = selectedProduct?.type === constants.TICKET;
    const infoDeliveryLabel = isInfo ? 'Entrega' : 'Entrega online';
    const isPhysicalNoFather = !isMainProduct && isPhysical;
    const isLoading = loading || saving;
    const currentProductTitleWithId = `${selectedProduct?.id || product?.id || ''} - ${selectedProduct?.title || product?.title || ''}`;
    const isDraft = selectedProduct.active === EProductStatus.DRAFT;
    const isMainSelected = isMainProduct && selectedProduct?.id === product?.id;
    const isFree = selectedProduct.charge_type === EChargeType.FREE;
    const isOpenValue = selectedProduct.charge_type === EChargeType.OTHER;

    const disableCreateVariationButton = isLoading || isDraft || isService || isTicket || isMainSelected;
    const variationTooltipButton = isDraft
      ? 'Não é possível criar variação de um produto que está como rascunho'
      : isMainSelected
      ? 'Crie variação somente com uma variação selecionada'
      : isTicket
      ? 'Esta ação só pode ser feita na Blinket'
      : '';
    const isBetaReadjustment = eduzzAccountsService.verifyUserHasBetaModule('assinaturas-reajuste');
    const isSinglePayment = product.charge_type === EChargeType.SINGLE;
    const hasOffersAccess = isSinglePayment && isInfo;

    const myTabs = [
      { name: eNameTabs.General, label: 'Geral', errors: generalRequiredFields, show: true },
      { name: eNameTabs.Sales, label: hasOffersAccess ? 'Preços e ofertas' : 'Vendas', errors: salesRequiredFields, show: !isMainProduct },
      { name: eNameTabs.PaymentMethods, label: 'Meios de pagamento', errors: paymentMethodsRequiredFields, show: !isFree && !isMainProduct },
      { name: eNameTabs.Coproducers, label: 'Parceiros', errors: coProducerRequiredFields, show: !isMainProduct },
      { name: eNameTabs.Affiliates, label: 'Afiliados', errors: affiliatesRequiredFields, show: true },
      { name: eNameTabs.InfoDelivery, label: infoDeliveryLabel, errors: InfoDeliveryRequiredFields, show: !isMainProduct },
      { name: eNameTabs.PhysicalDelivery, label: 'Entrega física', errors: PhysicalDeliveryRequiredFields, show: isPhysicalNoFather },
      { name: eNameTabs.SalesRecovery, label: 'Recuperação de vendas', errors: recoveryRequiredFields, show: !isMainProduct && !isOpenValue },
      { name: eNameTabs.Advanced, label: 'Avançado', errors: advancedRequiredFields, show: !isMainProduct },
    ];

    const coproducers = selectedProduct.getCoProducers();
    const hasElevarAdded = coproducers.some((coproducer) => PROJECT_ELEVAR_ID.includes(coproducer.customer_id));
    const coProducersLimit = hasElevarAdded ? coProducersLimitWithElevar : coProducersLimitWithoutElevar;
    const canAddCoproducer = coproducers.length < coProducersLimit;
    const coProducerErrorMessage = canAddCoproducer ? '' : 'Não é possível adicionar mais de 15 co-produtores para o mesmo produto';

    return (
      <>
        <Grid container spacing={2}>
          <Grid id='edit-product' container spacing={2} className={classes.titleMargin}>
            <Grid item xs={12}>
              <Breadcrumbs aria-label='breadcrumb'>
                <Link to='/producer/product/myproducts'>Meus produtos</Link>
                <p>{isService ? 'Edição do serviço' : 'Edição do produto'}</p>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12}>
              <Grid container justifyContent='space-between'>
                {isDraft && (
                  <Grid item xs={12} md={1}>
                    <DraftLabel />
                  </Grid>
                )}
                <Grid item xs={12} sm='auto'>
                  <Typography className={classes.titlePage}>
                    <Truncate count={hasVariations ? 70 : 60} final='...'>
                      {currentProductTitleWithId}
                    </Truncate>
                  </Typography>
                </Grid>

                <Grid item xs={12} sm='auto'>
                  <Tooltip title={variationTooltipButton}>
                    <div>
                      <Button
                        startIcon={isLoading ? <CircularProgress size={15} /> : <DynamicFeedOutlined />}
                        disabled={disableCreateVariationButton}
                        onClick={hasVariations ? this.newVariation : this.confirmCreateNewVariation}
                        variant='contained'
                        color='primary'
                      >
                        Nova variação
                      </Button>
                    </div>
                  </Tooltip>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Grid container justify='space-between' spacing={2}>
                {hasVariations && (
                  <Grid item md={4} xs={12}>
                    <div className={classes.allList} style={{ top: TOOLBAR_HEIGHT }}>
                      <div className={classes.topList}>
                        <ListItem button selected={selected === product.id} onClick={() => this.onChangeItem(product.id)} divider>
                          <ListItemAvatar>
                            <Avatar>
                              <SettingsIcon />
                            </Avatar>
                          </ListItemAvatar>
                          <ListItemText
                            primary={
                              <>
                                <h4>Configurações Gerais</h4>
                                <b>{product.id}</b>
                              </>
                            }
                            secondary={product.title}
                          />
                        </ListItem>
                        <ListItem dense divider>
                          <ListItemText
                            primary={
                              <h5>
                                Esse produto contém {variations?.length} {variations?.length > 1 ? 'variações' : 'variação'}
                              </h5>
                            }
                          />
                        </ListItem>
                        {hasVariations && !variations && <LinearProgress className={classes.loadingLinear} />}
                        <List dense className={classes.list}>
                          {(variations || []).map((item) => (
                            <ListItem selected={selected === item.id} key={item.id} button divider onClick={() => this.onChangeItem(item.id)}>
                              <ListItemAvatar>
                                <Avatar alt={`Imagem da Variação ${item.id}`} src={item.image}>
                                  <AddIcon />
                                </Avatar>
                              </ListItemAvatar>
                              <ListItemText
                                primary={
                                  item?.id ? (
                                    <>
                                      <p>
                                        <strong>{item.id}</strong>
                                      </p>
                                    </>
                                  ) : (
                                    'Nova variação'
                                  )
                                }
                                secondary={item.title}
                              />
                            </ListItem>
                          ))}
                        </List>
                      </div>
                    </div>
                  </Grid>
                )}

                <Grid item xs={12} md={hasVariations ? 8 : 12} style={{ position: 'relative' }}>
                  <Tabs variant='scrollable' scrollButtons='auto' value={tabSelected} onChange={this.handleChangeTab}>
                    {myTabs
                      .filter((t) => t.show)
                      .map((tab) => (
                        <Tab
                          id={`${tab.name}-tab`}
                          key={tab.name}
                          value={tab.name}
                          //classes={{ root: classes.tabRoot, wrapper: classes.label, selected: classes.tabSelected }}
                          label={<LabelTab label={tab.label} errors={tab.errors} classes={classes} />}
                        />
                      ))}

                    {!isLoading && selectedProduct?.id === 0 && (
                      <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Button variant='text' onClick={this.copyFromOriginal} style={{ float: 'right' }}>
                          Copiar do produto
                        </Button>
                      </div>
                    )}
                  </Tabs>
                  <div style={{ marginTop: 12 }}>
                    {tabSelected === eNameTabs.General && (
                      <General
                        loading={isLoading}
                        fade={tabSelected === eNameTabs.General}
                        handleChange={this.handleChange}
                        product={selectedProduct}
                        modifieds={modifieds}
                        handleImageChange={this.handleChange}
                        editing={editing}
                        categoryList={categories}
                        onChangeRequiredFields={this.onChangeRequiredFields}
                        variations={variations}
                      />
                    )}
                    {tabSelected === eNameTabs.Sales && (
                      <Sales
                        loading={isLoading}
                        currencyList={this.props.currencies}
                        fade={tabSelected === eNameTabs.Sales}
                        handleChange={this.handleChange}
                        product={selectedProduct}
                        modifieds={modifieds}
                        editing={editing}
                        onChangeRequiredFields={this.onChangeRequiredFields}
                        openConfirmModal={this.openConfirmModal}
                      />
                    )}
                    {tabSelected === eNameTabs.PaymentMethods && (
                      <PaymentMethods
                        loading={isLoading}
                        currencyList={this.props.currencies}
                        fade={tabSelected === eNameTabs.PaymentMethods}
                        handleChange={this.handleChange}
                        product={selectedProduct}
                        modifieds={modifieds}
                        editing={editing}
                        onChangeRequiredFields={this.onChangeRequiredFields}
                      />
                    )}
                    {tabSelected === eNameTabs.Coproducers && (
                      <CoProducer
                        loading={loadingCoProducers || saving}
                        fade={tabSelected === eNameTabs.Coproducers}
                        coproducers={selectedProduct.coproducers}
                        canAddCoproducer={canAddCoproducer}
                        coProducerErrorMessage={coProducerErrorMessage}
                        hasElevarAdded={hasElevarAdded}
                        onChange={this.handleChangeCoproducer}
                        onChangeRequiredFields={this.onChangeRequiredFields}
                      />
                    )}
                    {tabSelected === eNameTabs.Affiliates && (
                      <Affiliate
                        loading={loadingCoProducers || saving}
                        fade={tabSelected === eNameTabs.Affiliates}
                        handleChange={this.handleChange}
                        product={selectedProduct}
                        modifieds={modifieds}
                        editing={editing}
                        onChangeRequiredFields={this.onChangeRequiredFields}
                      />
                    )}
                    {tabSelected === eNameTabs.InfoDelivery && (
                      <InfoDelivery
                        loading={loadingDeliveryMethods || saving}
                        fade={tabSelected === eNameTabs.InfoDelivery}
                        deliveries={selectedProduct.deliveries}
                        classes={classes}
                        onChange={this.handleChangeDeliveries}
                        onChangeRequiredFields={this.onChangeRequiredFields}
                        isInfo={product.type == constants.INFO}
                        offer={selectedProduct}
                        isService={product.type == constants.SERVICE}
                      />
                    )}
                    {selectedProduct.type === constants.PHYSICAL && tabSelected === eNameTabs.PhysicalDelivery && (
                      <PhysicalDelivery
                        loading={loadingDeliveryMethods || saving}
                        fade={tabSelected === eNameTabs.PhysicalDelivery}
                        classes={classes}
                        onChangeRequiredFields={this.onChangeRequiredFields}
                        onAddPartner={this.onAddNewDeliveryPartner}
                        onRemovePartner={this.onRemoveDeliveryPartner}
                        product={product}
                      />
                    )}
                    {tabSelected === eNameTabs.SalesRecovery && (
                      <SalesRecovery
                        loading={isLoading}
                        currencyList={this.props.currencies}
                        fade={tabSelected === eNameTabs.SalesRecovery}
                        handleChange={this.handleChange}
                        product={selectedProduct}
                        modifieds={modifieds}
                        editing={editing}
                        onChangeRequiredFields={this.onChangeRequiredFields}
                      />
                    )}
                    {tabSelected === eNameTabs.Advanced && (
                      <AdvancedForm
                        loading={isLoading}
                        product={selectedProduct}
                        fade={tabSelected === eNameTabs.Advanced}
                        classes={classes}
                        onChangeRequiredFields={this.onChangeRequiredFields}
                        handleChange={this.handleChange}
                      />
                    )}

                    <div className={classes.saveContext}>
                      <Grid container justify='flex-end' className={classes.saveButtonDiv}>
                        {selectedProduct.active === EProductStatus.DRAFT ? (
                          <DraftButtons
                            disabled={{ tooltip: !isValid, button: isValid || loading || saving }}
                            disabledDraft={{ tooltip: !!product.title, button: !product.title }}
                            onSubmit={() => this.handleClickSubmit()}
                            onSubmitDraft={() => this.handleClickSubmitDraft()}
                            isService={isService}
                          />
                        ) : (
                          <Grid item xs={12} justifyContent='flex-end' className={classes.saveButton}>
                            <Tooltip
                              placement={'top'}
                              disableFocusListener={!isValid}
                              disableHoverListener={!isValid}
                              disableTouchListener={!isValid}
                              title={'Por favor verifique os campos inválidos antes de salvar'}
                            >
                              <div>
                                <Button
                                  color='primary'
                                  variant='contained'
                                  disabled={isValid || loading || saving}
                                  onClick={hasModifiedRecurringValue && isBetaReadjustment ? this.handleClickPriceSubmit : () => this.handleSubmit()}
                                  startIcon={<Save />}
                                >
                                  {saving ? 'Salvando...' : 'Salvar'}
                                </Button>
                              </div>
                            </Tooltip>
                          </Grid>
                        )}
                      </Grid>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <ModalActions
          title={'Atenção'}
          open={this.state.confirmModal}
          buttonOk={'Salvar'}
          buttonOkColor={'#009358'}
          buttonCancel={'Não salvar'}
          onOk={this.onOkModal}
          onClose={this.onCancelModal}
        >
          As alterações realizadas não foram salvas e serão perdidas, deseja salvar?
        </ModalActions>
        <ModalActions
          title={'Deseja realmente adicionar variações para este produto?'}
          open={this.state.variationModal}
          onClose={this.onVariationModalClose}
          onOk={this.onVariationModalOk}
          buttonOk={'Sim, adicionar variação'}
          buttonCancel={'Não'}
        >
          <p>
            Após a criação de uma variação o conteúdo deverá ter no <b>mínimo 2 variações</b>, esta alteração não poderá ser desfeita.
          </p>
          {product.connects > 0 && (
            <p style={{ marginTop: 10, fontWeight: 500 }}>
              Você possui {product.connects} {product.connects > 1 ? 'ações' : 'ação'} do connect{' '}
              {product.connects > 1 ? 'cadastradas' : 'cadastrada'} nesse produto, ajuste {product.connects > 1 ? 'as ações' : 'a ação'} do seu
              connect para essa variação.
            </p>
          )}
        </ModalActions>
      </>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    edit: state.orbita.Product.edit,
    product: state.orbita.Product.product,
    coproducers: state.orbita.Product.coProducers,
    delivery: state.orbita.Product.deliveryMethods,
    upload_id: state.orbita.Upload.upload.upload_id,
    categories: state.orbita.Product.categories,
    currencies: state.orbita.Currency.list,
    newProduct: state.orbita.Product.new.product,
    variations: state.orbita.Product.listProductsChildren.data,
    physicalDelivery: state.components.physicalDelivery,
    courses: state.orbita.NutrorCourse.list.courses,
    packages: state.orbita.NutrorCourse.list.packages,
    integration: state.orbita.Product.getDeliveryIntegrationActiveList,
  };
}

const LabelTab = ({ label, errors, classes }: { label: string | React.ReactNode; errors: number; classes: any }) => {
  if (!errors) return <>{label}</>;
  return (
    <Badge color='secondary' classes={{ badge: classes.badgeTab }} badgeContent={errors}>
      {label}
    </Badge>
  );
};

export default withRouter(connect(mapStateToProps)(styles(Product)));
